export { default as graphicConfirmation } from './graphic-confirmation.svg';
export { default as graphicCongratsJulaClub } from './graphic-congrats-julaclub.png';
export { default as graphicJulaPro } from './graphic-congrats-julapro.png';
export { default as grapichSigninBirthday } from './graphic-signin-birthday.svg';
export { default as graphicSigninMail } from './graphic-signin-mail.svg';
export { default as iconPinBlack } from './icon-pin-black.svg';
export { default as iconPinJula } from './icon-pin-jula.svg';
export { default as iconPinRed } from './icon-pin-red.svg';
export { default as iconTestFreaks } from './icon-testfreaks.svg';
